<section class="main-block">
    <app-header appTheme [showorderstatus]="showorderstatusdata" (notificationChangeEvent)="notificationChangeEventdata($event)">
    </app-header>

    <div class="mb-auto">
        <app-view-notification-details [notificationheader]="notificationheaderInfo" *ngIf="notificationheaderInfo">
        </app-view-notification-details>
    </div>
    <div class="mt-auto">
        <app-footer-site-info></app-footer-site-info>
    </div>

</section>